// extracted by mini-css-extract-plugin
export default {"usersTable":"BrowserUsedByUsers_usersTable__0GG6-"};